import { AxiosResponse } from "axios";
import {
  CalculateTipsRequest,
  CalculateTipsResponse,
  GetTipsByDateRangeResponse,
  GetTipsResponse,
  PayoutType,
  SaveTipPeriodRequest,
  SaveTipPeriodResponse,
  TipDetails,
} from "model/Tip";
import { axiosRequest } from "services/api/api.utils";
import { API_ROOT } from "services/baseURLs.config";

export const fetchTipsByMonth = async (
  companyId: number,
  month: string,
): Promise<AxiosResponse<GetTipsResponse>> => {
  return await axiosRequest.auth.get<GetTipsResponse>(
    `${API_ROOT}/companies/${companyId}/tips/${month}`,
  );
};

export const fetchTipsByDateRange = async (
  companyId: number,
  fromDate: string,
  toDate: string,
): Promise<AxiosResponse<GetTipsByDateRangeResponse>> => {
  return await axiosRequest.auth.get<GetTipsByDateRangeResponse>(
    `${API_ROOT}/companies/${companyId}/tips`,
    {
      params: {
        fromDate,
        toDate,
      },
    },
  );
};

export const createTipDate = async (
  companyId: number,
  date: string,
): Promise<AxiosResponse<TipDetails>> => {
  return await axiosRequest.auth.post<TipDetails>(
    `${API_ROOT}/companies/${companyId}/tips`,
    {
      date,
      amount: 0,
    },
  );
};

export const updateTipAmount = async (
  companyId: number,
  companyTipId: number,
  amount: number,
): Promise<AxiosResponse<TipDetails>> => {
  return await axiosRequest.auth.put<TipDetails>(
    `${API_ROOT}/companies/${companyId}/tips/${companyTipId}`,
    {
      amount,
    },
  );
};

export const fetchTipById = async (
  companyId: number,
  companyTipId: number,
): Promise<AxiosResponse<TipDetails>> => {
  return await axiosRequest.auth.get<TipDetails>(
    `${API_ROOT}/companies/${companyId}/tips/${companyTipId}`,
  );
};

export const deleteTip = async (
  companyId: number,
  companyTipId: number,
): Promise<AxiosResponse<void>> => {
  return await axiosRequest.auth.delete<void>(
    `${API_ROOT}/companies/${companyId}/tips/${companyTipId}`,
  );
};

export const calculateTipsDistribution = async (
  companyId: number,
  request: CalculateTipsRequest,
): Promise<AxiosResponse<CalculateTipsResponse>> => {
  return await axiosRequest.auth.post<CalculateTipsResponse>(
    `${API_ROOT}/companies/${companyId}/tips/calculate`,
    request,
  );
};

export const saveTipsDistribution = async (
  companyId: number,
  request: SaveTipPeriodRequest[],
): Promise<AxiosResponse<SaveTipPeriodResponse>> => {
  return await axiosRequest.auth.post<SaveTipPeriodResponse>(
    `${API_ROOT}/companies/${companyId}/tips/save`,
    request,
  );
};

export const payoutTips = async (
  companyId: number,
  companyTipIds: number[],
  payoutType: PayoutType,
): Promise<AxiosResponse<void>> => {
  return await axiosRequest.auth.post<void>(
    `${API_ROOT}/companies/${companyId}/tips/payout`,
    {
      companyTipIds,
      payoutType,
    },
  );
};

export const cancelTips = async (
  companyId: number,
  companyTipIds: number[],
  payoutType: PayoutType,
): Promise<AxiosResponse<TipDetails[]>> => {
  return await axiosRequest.auth.put<TipDetails[]>(
    `${API_ROOT}/companies/${companyId}/tips/cancel`,
    {
      companyTipIds,
      payoutType,
    },
  );
};
